export const imageAccommodation = {
  breadcrumbCurrent: "Logo obiektu",
  heading: "Logo Twojej oferty",
  subtitle:
    "Prześlij logo, które identyfikuje tę ofertę. Dozwolone formaty: PNG, JPG, SVG · maks. 5 MB.",
  savedLogoAlt: "Zapisane logo",
  activeBadge: "Aktywne logo",
  change: "Zmień",
  drop: {
    release: "Upuść tutaj",
    newLogo: "Nowe logo",
    uploadLogo: "Prześlij swoje logo",
    dragOr: "Przeciągnij lub",
    clickLink: "kliknij",
    formats: "PNG · JPG · SVG · maks. 5 MB",
  },
  importButton: "Importuj logo z innej oferty",
  crop: {
    removeImage: "Usuń obraz",
    tip: "Przesuń i dopasuj kadr. Proporcje 2:1 (idealne dla poziomych logo).",
    saving: "Zapisywanie…",
    save: "Zapisz logo",
  },
  actions: {
    cancel: "Anuluj",
  },
  applyModal: {
    title: "Zastosować w innych ofertach?",
    subtitle: "Wybierz oferty, do których chcesz skopiować to samo logo.",
    logoAlt: "Logo",
    selectAll: "Zaznacz wszystkie",
    progress: "Stosowanie {done}/{total}…",
    skip: "Pomiń",
    applying: "Stosowanie…",
    applyToBtn: "Zastosuj w {count} ofercie | Zastosuj w {count} ofertach | Zastosuj w {count} ofertach",
  },
  importModal: {
    title: "Importuj logo",
    subtitle: "Wybierz logo z innej oferty, aby użyć go w tej.",
    loading: "Wczytywanie ofert…",
    empty: "Żadna oferta nie ma jeszcze logo.",
    progress: "Importowanie logo…",
    importing: "Importowanie…",
  },
  defaultListingName: "Oferta",
  toasts: {
    invalidFormat: "Nieprawidłowy format. Użyj PNG, JPG lub SVG.",
    fileTooLarge: "Plik przekracza limit {max} MB.",
    selectBeforeSave: "Wybierz i dopasuj logo przed zapisaniem.",
    propertyNotFound: "Nie znaleziono obiektu powiązanego z tą ofertą.",
    saveSuccess: "Logo zapisane pomyślnie",
    saveError: "Błąd zapisu logo.",
    listingLoadError: "Nie udało się wczytać danych oferty.",
    applySuccess:
      "Logo zastosowano pomyślnie w {count} ofercie | Logo zastosowano pomyślnie w {count} ofertach | Logo zastosowano pomyślnie w {count} ofertach",
    applyError:
      "Nie udało się zastosować w {count} ofercie | Nie udało się zastosować w {count} ofertach | Nie udało się zastosować w {count} ofertach",
    listingsLoadError: "Nie udało się wczytać ofert.",
    propertyNotFoundImport: "Nie znaleziono obiektu dla tej oferty.",
    importSuccess: 'Logo z oferty „{name}” zaimportowane pomyślnie',
    importError: "Błąd importu logo.",
  },
};
